import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import UpdatePasswordScreen from "@/screens/Settings/Security/UpdatePasswordScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <UpdatePasswordScreen {...props} />;
}

export default withSessionHandling(Page);
